import Flux from '../flux/Flux';
import { VXPay, VXPayAction } from '../utils/VXPay';

/**
 * @param {number} actorId
 * @param {?number} albumId
 * @param {number} value === Flux.Constants.Ratings.AlbumLike|Flux.Constants.Ratings.AlbumDislike
 */
function voteMedia(actorId, albumId, value) {
	if (Flux.Guest.isLoggedIn()) {
		if (albumId) {
			Flux.Gallery.setGuestRating(albumId, value);
		} else {
			Flux.Gallery.setSedcardsGuestRating(actorId, value);
		}
	} else {
		let actionType = Flux.Constants.ActionTypes.Gallery.GALLERY_SET_SEDCARDS_GUEST_RATING;
		let targetId = actorId;
		if (albumId) {
			actionType = Flux.Constants.ActionTypes.Gallery.SET_GUEST_RATING;
			targetId = albumId;
		}
		const action = new VXPayAction(actionType, {
			targetId: targetId,
			value: value,
		});
		VXPay.openSignupOrLogin({}, action);
	}
}

/**
 * @param {number} actorId
 * @param {?number} albumId
 */
function likeMedia(actorId, albumId) {
	voteMedia(actorId, albumId, Flux.Constants.Ratings.AlbumLike);
}

/**
 * @param {number} actorId
 * @param {?number} albumId
 */
function dislikeMedia(actorId, albumId) {
	voteMedia(actorId, albumId, Flux.Constants.Ratings.AlbumDislike);
}

export { likeMedia, dislikeMedia };
